// src/routes/PublicRoute.js
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function PublicRoute() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    // Only trigger login on the EXACT "/" path
    if (window.location.pathname === "/" && !isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  // Auth0 still loading → show spinner
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Authenticated → go to home
  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return null;
}
